export default __webpack_public_path__ + "static/media/primeinitiative.95d71d16.png";